const AuditProgress = ({ progress, isAuthenticated, onRetry, url }) => {
  return (
    <div style={{ marginTop: 16, maxWidth: '600px', margin: '20px auto 0' }}>
      {url && (
        <div style={{ marginBottom: 20, textAlign: 'center', fontSize: '1.1rem', fontWeight: '600', color: 'var(--text-heading)' }}>
          Auditing: <span style={{ color: 'var(--accent)', wordBreak: 'break-all' }}>{url}</span>
        </div>
      )}

      {!progress ? (
        <div className="card" style={{ textAlign: 'center', padding: '40px' }}>
          <div className="loading" style={{ justifyContent: 'center' }}>Connecting to audit engine...</div>
          <p style={{ marginTop: 12, color: 'var(--text-muted)', fontSize: '0.9rem' }}>
            This usually takes just a few seconds.
          </p>
        </div>
      ) : (
        <div className="progress-container" style={{ marginTop: 0 }}>
          {!progress.error && (
            <div className="progress-bar-track">
              <div className="progress-bar-fill" style={{ width: `${progress.percent || 0}%` }} />
            </div>
          )}
          <div className={`progress-info${progress.error ? " progress-error" : ""}`}>
            <span className="progress-label">{progress.error ? "Audit Failed" : progress.label}</span>
            {!progress.error && <span className="progress-percent">{progress.percent || 0}%</span>}
          </div>
          {progress.error ? (
            <div className="progress-error-details">
              <p style={{ fontWeight: 600, marginBottom: 4 }}>Error Details:</p>
              {progress.error}
              {onRetry && (
                <div style={{ marginTop: 16 }}>
                  <button className="btn btn-primary" onClick={onRetry}>
                    Try Another URL
                  </button>
                </div>
              )}
            </div>
          ) : progress.step ? (
            <div className="progress-steps">
              Step {progress.step} of {progress.totalSteps}.
              {isAuthenticated ? " Finished audits are saved to your history." : ""}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default AuditProgress;